export default {"src":"/_next/static/media/0xe2f2a5c287993345a840db3b0845fbc70f5935a5.e02639dd.svg","height":330,"width":330,"blurWidth":0,"blurHeight":0};